import { render, staticRenderFns } from "./fDialog.template?vue&type=template&id=62f27a5e&lang=pug&"
import script from "./fDialog.client?vue&type=script&lang=ts&"
export * from "./fDialog.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f27a5e')) {
      api.createRecord('62f27a5e', component.options)
    } else {
      api.reload('62f27a5e', component.options)
    }
    module.hot.accept("./fDialog.template?vue&type=template&id=62f27a5e&lang=pug&", function () {
      api.rerender('62f27a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fDialog/fDialog.component.vue"
export default component.exports